import { useEffect } from "react"

import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom"

import { useGetEnabledModulesInApp } from "@l2r-front/l2r-networks"

import { appSafety } from "../../constants/appSafety"
import { SafetyDesktopLayout } from "../../layouts/SafetyDesktopLayout"

export function SafetyDesktopRouter() {

    const enabledSafetyModule = useGetEnabledModulesInApp(appSafety)
    const location = useLocation()
    const matchEnabledModule = enabledSafetyModule?.find(m => location.pathname.includes(m.path))
    const navigate = useNavigate()

    useEffect(() => {
        if (!matchEnabledModule) {
            navigate(`${enabledSafetyModule?.[0]?.path || ""}`)
        }
    }, [enabledSafetyModule, matchEnabledModule, navigate])

    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <SafetyDesktopLayout />
                }
            />
            <Route
                path="/"
                element={
                    <Navigate replace to={enabledSafetyModule?.[0]?.path ? enabledSafetyModule?.[0]?.path : ""} />
                }
            />
        </Routes>
    )
}
